import { render, staticRenderFns } from "./ShippingCostApproval.vue?vue&type=template&id=7984ed41&scoped=true&"
import script from "./ShippingCostApproval.vue?vue&type=script&lang=js&"
export * from "./ShippingCostApproval.vue?vue&type=script&lang=js&"
import style0 from "./ShippingCostApproval.vue?vue&type=style&index=0&id=7984ed41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7984ed41",
  null
  
)

export default component.exports